
export function pluralize(word, count, pluralForm = '') {
  if (count <= 1) {
    return word
  }
  return pluralForm || `${word}s`
}

export function capitalize(str, options = {}) {
  if (!str || typeof str !== 'string') {
    return String(str || '') || '';
  }
  const capitalizeWord = (word = '') =>  word[0].toUpperCase() + word.slice(1)
  if (options.all) {
    return str.split(' ').map(word => capitalizeWord(word)).join(' ')
  }
  return capitalizeWord(str)
}

export const headingRegExp = /h[1-7]/;
export const headingPseudoNameRegExp = /{{(.*?)}}/;

export const slugify = (str) =>
  str
    ?.replace?.(/[&^%$#@!)(*.?,)]/g, '')
    ?.replace(/\s+/g, ' ')
    ?.trim()
    ?.replace?.(/\s/g, '-')
    ?.toLowerCase?.() || '';
  
export const reverse = (str) => 
  str ? str.split('').reverse().join('') : str
